import React, { useState } from "react";
import {useNavigate,Link } from "react-router-dom";
import "./Header.css";
// import logo from "../assets/images/logo.png"; // your logo file path

const Header = () => {
  const navigate = useNavigate();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  // 🔹 Example: Button click function for Admin Login
  const handleAdminClick = () => {
    navigate("/admin/AdminLogin");
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <header className="header">
      {/* 🔹 Top Bar */}
      <div className="top-bar">
        <div className="top-links">
          <a href="#students">Students</a>
          <a href="#careers">Careers</a>
          <a href="#downloads">Downloads</a>
          <a href="#webmail">Webmail</a>
        </div>
      </div>

      {/* 🔹 Main Navbar */}
      <div className="main-nav">
        <Link to="/" className="logo-area">
          {/* <img src={logo} alt="Alasar Academy Logo" /> */}
          <div className="logo-text">
            <h2>Alasar Academy</h2>
            <p>Discovering Knowledge</p>
          </div>
        </Link>

        <button className="mobile-menu-btn" onClick={toggleMobileMenu}>
          {isMobileMenuOpen ? '✕' : '☰'}
        </button>

        <nav className={`nav-links ${isMobileMenuOpen ? 'active' : ''}`}>
          <a href="#about" onClick={() => setIsMobileMenuOpen(false)}>About</a>
          <a href="#academics" onClick={() => setIsMobileMenuOpen(false)}>Academics</a>
          <a href="#admissions" onClick={() => setIsMobileMenuOpen(false)}>Admissions</a>
          {/* <a href="#research" onClick={() => setIsMobileMenuOpen(false)}>Research</a> */}
          {/* <a href="#international" onClick={() => setIsMobileMenuOpen(false)}>International</a> */}
          {/* <a href="#campus" onClick={() => setIsMobileMenuOpen(false)}>Campus</a> */}
          <a href="#facilities" onClick={() => setIsMobileMenuOpen(false)}>Facilities</a>
          <button onClick={() => { handleAdminClick(); setIsMobileMenuOpen(false); }} className="admin-link">Admin</button>
        </nav>
      </div>
    </header>
  );
};

export default Header;
